import { gql } from '@/shared/graphql/generated/cache';

export const getAllValidatorsQuery = gql(/* GraphQL */ `
  query ValidatorsWithMinActiveBid($filter: ValidatorFilter) {
    validators: allValidators(filter: $filter) {
      nodes {
        ...CacheValidator
      }
    }
    auction: auctionById(id: 1) {
      minActiveBid
    }
  }
`);

export const getApyValidators = gql(/* GraphQL */ `
  query GetApyValidators {
    validators: allValidators(filter: { apyBp: { greaterThan: 0 } }, orderBy: TOTAL_BALANCE_DESC) {
      nodes {
        ...CacheValidator
      }
    }
  }
`);

export const getValidatorsByIdSs58Query = gql(/* GraphQL */ `
  query GetValidatorsByAccountIds($idSs58s: [String!]!) {
    validators: allValidators(filter: { idSs58: { in: $idSs58s } }) {
      nodes {
        ...CacheValidator
      }
    }
  }
`);

export const getCurrentAuthoritiesOnlineStatusQuery = gql(/* GraphQL */ `
  query GetCurrentAuthoritiesOnlineStatus {
    validators: allValidators(filter: { isCurrentAuthority: { equalTo: true } }) {
      nodes {
        idSs58
        isOnline
      }
    }
  }
`);

export const getLinkedAccounts = gql(/* GraphQL */ `
  query GetLinkedAccounts($ethAddress: String!, $idSs58s: [String!]!) {
    links: allAccountLinks(condition: { ethereumAddress: $ethAddress }) {
      nodes {
        accountIdSs58
      }
    }
    unregistered: allUnregistereds(filter: { idSs58: { in: $idSs58s } }) {
      nodes {
        idSs58
      }
    }
  }
`);

export const getOnlineAuthorityCountsQuery = gql(/* GraphQL */ `
  query GetOnlineAuthorityCounts {
    authorities: allValidators(filter: { isCurrentAuthority: { equalTo: true } }) {
      totalCount
    }
    online: allValidators(
      filter: { isCurrentAuthority: { equalTo: true }, isOnline: { equalTo: true } }
    ) {
      totalCount
    }
  }
`);
